const progress = (value) => {
    document.getElementsByClassName('progress-bar')[0].style.width = `${value}%`;
}

var step, prevBtn, nextBtn, submitBtn, form, preloader, bodyElement, successDiv;

$(document).ready(function () {
    step = document.getElementsByClassName('step');
    prevBtn = document.getElementById('prev-btn');
    nextBtn = document.getElementById('next-btn');
    submitBtn = document.getElementById('submit-btn');
    form = document.getElementsByTagName('form')[0];
    preloader = document.getElementById('preloader-wrapper');
    bodyElement = document.querySelector('body');
    successDiv = document.getElementById('success');

    if (typeof form !== 'undefined') {
        form.onsubmit = () => {
            //return false
            //validateRequired(current_step);
            return validateRequired(currentStep) && currentStep === stepCount;
        }
    }
});

var currentStep = 0;
var stepCount = 6;


window.getCurrentStep = function () {
    console.log("Current step: " + currentStep.toString() + " / " + stepCount.toString());
};

$(document).ready(function () {
    if (step[currentStep]) {
        step[currentStep].classList.add('d-block');

        if (currentStep == 0) {
            prevBtn.classList.add('d-none');
            submitBtn.classList.add('d-none');
            nextBtn.classList.add('d-inline-block');
        }


        nextBtn.addEventListener('click', () => {
            let validate = validateRequired(currentStep);
            if (validate) {
                currentStep++;
                let previous_step = currentStep - 1;
                if ((currentStep > 0) && (currentStep <= stepCount)) {
                    prevBtn.classList.remove('d-none');
                    prevBtn.classList.add('d-inline-block');
                    step[currentStep].classList.remove('d-none');
                    step[currentStep].classList.add('d-block');
                    step[previous_step].classList.remove('d-block');
                    step[previous_step].classList.add('d-none');
                    if (currentStep == stepCount) {
                        submitBtn.classList.remove('d-none');
                        submitBtn.classList.add('d-inline-block');
                        nextBtn.classList.remove('d-inline-block');
                        nextBtn.classList.add('d-none');
                    }
                } else {
                    if (currentStep > stepCount) {
                        form.onsubmit = () => {
                            validateRequired(currentStep);
                            return $("input[type=checkbox].required:not(:checked)").length === 0
                        }
                    }
                }
                progress((100 / stepCount) * currentStep);
            }
        });


        prevBtn.addEventListener('click', () => {
            if (currentStep > 0) {
                currentStep--;
                let previous_step = currentStep + 1;
                prevBtn.classList.add('d-none');
                prevBtn.classList.add('d-inline-block');
                step[currentStep].classList.remove('d-none');
                step[currentStep].classList.add('d-block')
                step[previous_step].classList.remove('d-block');
                step[previous_step].classList.add('d-none');
                if (currentStep < stepCount) {
                    submitBtn.classList.remove('d-inline-block');
                    submitBtn.classList.add('d-none');
                    nextBtn.classList.remove('d-none');
                    nextBtn.classList.add('d-inline-block');
                    prevBtn.classList.remove('d-none');
                    prevBtn.classList.add('d-inline-block');
                }
            }

            if (currentStep == 0) {
                prevBtn.classList.remove('d-inline-block');
                prevBtn.classList.add('d-none');
            }
            progress((100 / stepCount) * currentStep);
        });


        /*submitBtn.addEventListener('click', () => {
            preloader.classList.add('d-block');

            const timer = ms => new Promise(res => setTimeout(res, ms));

            timer(3000)
                .then(() => {
                    bodyElement.classList.add('loaded');
                }).then(() => {
                step[stepCount].classList.remove('d-block');
                step[stepCount].classList.add('d-none');
                prevBtn.classList.remove('d-inline-block');
                prevBtn.classList.add('d-none');
                submitBtn.classList.remove('d-inline-block');
                submitBtn.classList.add('d-none');
                successDiv.classList.remove('d-none');
                successDiv.classList.add('d-block');
            })
        });*/
    }
})

$('.required').on('click', function () {
    $(this).removeClass('is-valid').removeClass('is-invalid');
})

// $('.select2-form').select2();
let $eventSelect = $('.select2-form');
$eventSelect.select2();

// $eventSelect.on("select2:select", function (event) {
$('[type=radio]').on("change", function (event) {
    let condValue = $(event.currentTarget).val();
    let condName = $(event.currentTarget).attr('name');
    console.log($(event.currentTarget).val());
    console.log($(event.currentTarget).attr('name'));


    $(form)
        .find('.visible-if')
        .each(function (i, k) {
            let condition = $(k).data('visibleif');
            if(condition.includes(condName)) {
                if(condition === condName+'='+condValue) {
                    $(k).slideDown();
                } else {
                    $(k).slideUp();
                }
            }
            console.log();
        });
});

// $(document).on('select2:select', function () {
//     console.log(this);
// });

function validateRequired(currentStep) {
    let inputs = $(step[currentStep]).find('.required');

    if (inputs.length === 0) {
        return true;
    }

    let invalidCount = 0;

    $(step[currentStep])
        .find('.required')
        .each(function (i, k) {
            if ($(k).is('input[type=text],textarea')) {
                $(k).removeClass('is-invalid').removeClass('is-valid');
                if ($(k).val().length === 0 || $(k).val().length < 3 || $(k).val() === null) {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                } else {
                    $(k).addClass('is-valid')
                }
            }
            if ($(k).is('input[type=checkbox],input[type=radio]')) {
                if ($(k).is(':checked')) {
                    $(k).addClass('is-valid')
                } else {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                }
            }
            if ($(k).is('select')) {
                if ($(k).val() !== null) {
                    $(k).addClass('is-valid')
                } else {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                }
            }
        })

    // $(step[currentStep])
    //     .find('.is-email')
    //     .each(function (i, k) {
    //         if ($(k).is('input[type=text],textarea')) {
    //             $(k).removeClass('is-invalid').removeClass('is-valid');
    //             if ($(k).val().length === 0 || $(k).val().length < 3 || $(k).val() === null) {
    //                 $(k).addClass('is-invalid')
    //                 invalidCount++;
    //             } else {
    //                 $(k).addClass('is-valid')
    //             }
    //         }
    //     })

    return invalidCount === 0;
}


function validateEmail(input) {
    let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (input.value.match(validRegex)) {
        alert("Valid email address!");
        return true;

    } else {
        alert("Invalid email address!");

        return false;
    }
}
